export default "__VITE_ASSET__C9PQtVAE__"